import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LanguageCode, LanguageFileName } from '../Models/WidgetSettingsModels';
import { LayoutService } from 'src/app/layout/layout.service';
import { urlConfig } from '../constants/url-config';

@Injectable({
    providedIn: 'root'
})
export class LocalizeService {

    constructor(public translateService: TranslateService,
        public ls: LayoutService, private http: HttpClient) { }

    public setLanguage(language: string, propertyType: string, literalsFolder?: string): Promise<void> {
        return new Promise<void>((resolve) => {
        let translationPath = '';

        if (!language) {
            language = LanguageFileName[Number(LanguageFileName.english)];
        }

        const applyExistingFallback = () => {
            const property = literalsFolder ? literalsFolder : window.location.href.split('/')[5];
            translationPath = 'customLiterals/' + property + '/' + language.toLowerCase();
            if(propertyType === 'commentcard') {
            translationPath = 'customLiterals/' + 'commentcard/' + property + '/' + language.toLowerCase();
            }
            let customLiteralsPathAvailable = false;
            this.translateService.use(translationPath).subscribe(() => {
                customLiteralsPathAvailable = true;
                this.setTranslatePath(translationPath, language, propertyType, language, resolve);
            }, () => {
                if (!customLiteralsPathAvailable) {
                    translationPath = this.getFallbackLangPath(language, propertyType);
                    this.setTranslatePath(translationPath, language, propertyType, language, resolve);
                }
            });
        };

        const endpoint = urlConfig.getCustomLiterals || ((environment.BaseUrl || '') + '/widget/GetCustomLiterals');
        const source = literalsFolder && literalsFolder.indexOf('/') === -1 ? literalsFolder.trim() : '';
        const params = 'code=' + encodeURIComponent(language) + (source ? '&source=' + encodeURIComponent(source) : '');

        if (!(window as any)['fetchStylesLiteralsFromBlob']) {
            applyExistingFallback();
            return;
        }

        this.http.get<any>(endpoint + '?' + params).subscribe(response => {
            const blobUrl = response?.Payload?.downloadUrl || '';
            if (!blobUrl) {
                applyExistingFallback();
                return;
            }

            this.http.get<any>(blobUrl).subscribe(literals => {
                const normalizedLanguage = language.toLowerCase();
                this.translateService.setTranslation(normalizedLanguage, literals || {}, true);
                this.translateService.use(normalizedLanguage).subscribe(() => {
                    this.ls.language = Number((LanguageFileName as any)[normalizedLanguage]);
                    sessionStorage.setItem('languageId', (LanguageFileName as any)[normalizedLanguage]);
                    sessionStorage.setItem('languageCode', (LanguageCode as any)[normalizedLanguage]);
                    resolve();
                }, () => {
                    applyExistingFallback();
                });
            }, () => {
                applyExistingFallback();
            });
        }, () => {
            applyExistingFallback();
        });
        });
    }

    private setTranslatePath(path: string, language: string, propertyType: string | null, fallbackLang: string | null, resolve?: () => void) {
        this.translateService.use(path).subscribe(() => {
            language = language?.toLowerCase();
            this.ls.language = Number((LanguageFileName as any)[language]);
            sessionStorage.setItem('languageId', (LanguageFileName as any)[language]);
            sessionStorage.setItem('languageCode', (LanguageCode as any)[language]);
            resolve?.();
        }, () => {
            if (fallbackLang && propertyType) {
                this.setTranslatePath(this.getFallbackLangPath(fallbackLang, propertyType), language, propertyType, null, resolve);
            } else if (propertyType) {
                this.setTranslatePath(this.getFallbackLangPath(LanguageFileName[Number(LanguageFileName.english)], propertyType), language, null, null, resolve);
            } else {
                resolve?.();
            }
        });
    }

    private getFallbackLangPath(language: string, propertyType: string): string {
        this.ls.language = (LanguageFileName as any)[language] || LanguageFileName.english;
        return propertyType + '/' + language.toLowerCase();
    }
}